import { DTOInterface } from "../interfaces/dto.interface";
import { Guid } from "guid-typescript";
import { TropaTransporteDTE } from "./tropa-transporte-dte";

export class TropaTransporte implements DTOInterface { 
	TransporteID: Guid;
	TropaRef: Guid;
	Fecha: Date;
	DTEProveedorTransporte: string;
	GastoFlete: number;

	DTEs: TropaTransporteDTE[];

	constructor() {
		this.clear();
	}

	clear(): void {
		this.TransporteID = Guid.createEmpty();
		this.TropaRef = Guid.createEmpty();
        this.Fecha = new Date(); 
		this.DTEProveedorTransporte = ''; 
		this.GastoFlete = 0;

		this.DTEs = [];
	}
}
